var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { createGlobalStyle } from 'styled-components';
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var family = _ref.theme.yoga.baseFont.family;
  return "\n    body {\n      font-family: \"" + family + "\";\n    }\n  ";
});
export default GlobalStyle;